exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-0486df92] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n}\n.loader svg[data-v-0486df92] {\n  width: 50px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}", ""]);

// exports
